export default "__VITE_ASSET__Bpebj0kI__"